import React from "react";
import dateFormat from "dateformat";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
const SingleItem = ({ data, index }) => {
  return (
    <>
      <tr>
        <td data-label="Coin | Transaction">
          <span className="fw-bold">
            {data?.currency}
          </span>
          <br />
          <small>{data?.transaction}</small>
        </td>
        <td data-label="Initiated">
          {dateFormat(data.createdAt, "d-m-yyyy h:MM:ss TT")}
          {/* <br />  1 week ago */}
        </td>

        <td data-label="Full Name">
          <Link to={`/admin/user/details/${data?.user_id?._id}`}>
            <span className="fw-bold">
              {data?.user_id?.username}
            </span>
            <br />
            {data?.user_id?.uid}
          </Link>
        </td>
        <td data-label="Email">
          {data?.network}
        </td>

        <td data-label="Amount">
          <strong title="" data-bs-original-title="Amount after charge">
            {data?.amount} USD
          </strong>
        </td>

        <td data-label="Status">
          {data.status === 0 ? (
            <span className="badge badge--warning text-warning">Pending</span>
          ) : (
            ""
          )}
          {data.status === 1 ? (
            <span className="badge badge--success text-success">Approved</span>
          ) : (
            ""
          )}
          {data.status === 2 ? (
            <span className="badge badge--danger text-danger">Rejected</span>
          ) : (
            ""
          )}
        </td>
        <td data-label="Action">
          <Link
            to={`/admin/withdraw/details/${data._id}`}
            className="btn btn-sm btn-outline-primary ms-1"
          >
            <i className="la la-desktop"></i> Details{" "}
          </Link>
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
